import { render, staticRenderFns } from "./politica-devoluciones.vue?vue&type=template&id=79b384da&lang=html&"
import script from "./politica-devoluciones.vue?vue&type=script&lang=js&"
export * from "./politica-devoluciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports